module.exports = __webpack_public_path__ + "logo.2acae5f0.png";